<h2 mat-dialog-title>Select and reorder columns</h2>

<div mat-dialog-content>
    <mat-selection-list [(ngModel)]="selected" cdkDropList [cdkDropListData]="data.allColumns"
        (cdkDropListDropped)="drop($event)">
        @for (col of data.allColumns; track col.key) {
        <mat-list-option cdkDrag [value]="col.key">
            <mat-icon cdkDragHandle style="padding-right:10px; cursor:grab">
                drag_indicator
            </mat-icon>
            {{ col.label }}
        </mat-list-option>
        }
    </mat-selection-list>
</div>

<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button [mat-dialog-close]="{selected: selected, allColumns: data.allColumns}">Apply</button>
    <button mat-button (click)="reset()">Reset to default</button>
</div>